import {
  Box,
  List,
  capitalize,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { useEasierTheme } from "datalign-themes";
import React, { useMemo, useState } from "react";
import FacetFilter from "models/facet-filter";
import Filter from "../filter";

const MAX_VISIBLE = 5;

const NTFilterList = ({
  facetType,
  facetFilters,
  index,
  open,
  OnUpdated,
  HandleOpen,
}: {
  facetType: string;
  facetFilters?: FacetFilter[];
  index: number;
  open: boolean;
  OnUpdated: (filterType: string, filter: string) => void;
  HandleOpen: (open: boolean) => void;
}) => {
  const easierTheme = useEasierTheme();

  const [filterSearch, setFilterSearch] = useState<string>();

  const searchedFilters = useMemo(
    () =>
      facetFilters?.filter((filter) =>
        filter.field.toLowerCase().includes(filterSearch?.toLowerCase() ?? ""),
      ),
    [facetFilters, filterSearch],
  );

  const visibleFilters = open
    ? searchedFilters
    : searchedFilters?.slice(0, MAX_VISIBLE);

  return (
    <Box>
      <Box
        sx={{
          bgcolor: ["FAF-nt", "nrdata-orig"].includes(
            process.env.REACT_APP_STYLING_THEME ?? "",
          )
            ? "#E35205"
            : easierTheme?.Colour.Secondary(),
          display: "flex",
          px: 2,
          py: 1,
          marginTop: index === 0 ? 0 : 2,
        }}
      >
        <Typography
          sx={{
            color: easierTheme?.Colour.OnSecondary(),
            alignSelf: "center",
            m: "auto auto auto 0",
            pr: 1,
            ...(["FAF-nt", "nrdata-orig"].includes(
              process.env.REACT_APP_STYLING_THEME ?? "",
            )
              ? {
                  letterSpacing: 0.3,
                  lineHeight: 1.6,
                  fontSize: "0.813rem",
                  fontWeight: 400,
                }
              : {
                  borderTopRightRadius: "4px",
                  borderTopLeftRadius: "4px",
                  borderBottomRightRadius: !open ? "4px" : undefined,
                  borderBottomLeftRadius: !open ? "4px" : undefined,
                }),
          }}
        >
          {capitalize(facetType)}
        </Typography>
        <TextField
          size="small"
          placeholder="Search..."
          value={filterSearch ?? ""}
          onChange={(e) => setFilterSearch(e.target.value)}
          sx={{
            color: easierTheme?.Colour.OnSecondary(),
            bgcolor: easierTheme?.Colour.Surface(),
            borderRadius: "4px",
            "& .MuiInputBase-input": { fontSize: 10, padding: 1 },
          }}
        />
      </Box>
      <Box
        sx={{
          background: easierTheme?.Colour.Surface(),
        }}
      >
        <List component="div" disablePadding>
          {facetFilters &&
            visibleFilters?.map((facetFilter, index) => (
              <Filter
                facetListLength={facetFilters.length}
                index={index}
                key={`filter-${facetFilter.field}`}
                filter={facetFilter}
                facetType={facetType}
                OnUpdated={OnUpdated}
              />
            ))}
        </List>

        {searchedFilters && searchedFilters.length > MAX_VISIBLE && (
          <Button
            size="small"
            onClick={() => HandleOpen(!open)}
            sx={{
              textTransform: "none",
              width: "100%",
              border: "solid",
              borderWidth: 1,
              borderBottomLeftRadius: "4px",
              borderBottomRightRadius: "4px",
              ...(["FAF-nt", "nrdata-orig"].includes(
                process.env.REACT_APP_STYLING_THEME ?? "",
              )
                ? {
                    borderColor: "rgba(0, 0, 0, 0.125)",
                    background: "#ffffff",
                  }
                : {
                    borderColor: easierTheme?.Colour.SecondaryContainer(),
                  }),
            }}
          >
            {open ? "Show less..." : "Show more..."}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default NTFilterList;
